import { type RootState } from "features/Application/store/store";

export const selectEmbeddedVideo = (state: RootState) => state.assets.embeddedVideo.current;
export const selectEmbeddedVideoStatus = (state: RootState) => state.assets.embeddedVideo.status;
export const selectEmbeddedVideoError = (state: RootState) => state.assets.embeddedVideo.errorMessage;
export const hasAccessSelector = (state: RootState) => state.assets.embeddedVideo.hasAccess;
